<div class="search-form-wrapper">
  <div id="tour-2" class="search">
    @if (searchApiError) {
      <pl-alert color="error" display="block">
        <span header>{{ searchApiError.title }}</span>
        <span content>{{ searchApiError.description }}</span>
      </pl-alert>
    }

    <div class="search-input-container">
      <seds-search
        #sedsSearch
        class="search-form-input search-form-input--with-actions"
        [ngClass]="{ 'search-form-input--error': inputError }"
        [color]="inputError ? 'error' : undefined"
        label="Digite nome, e-mail ou logon para pesquisar"
        (search)="onSearchSubmit($event)"
        (keyup)="onSearchInput($event)"
      ></seds-search>

      @if (!searchExecuted) {
        <button
          class="search-button"
          type="button"
          aria-label="Pesquisar"
          (click)="onSearchButtonClick()"
        >
          <mat-icon fontSet="material-icons">search</mat-icon>
        </button>
      }

      @if (searchExecuted) {
        <button
          class="clear-button"
          type="button"
          (click)="searchUser('', true)"
          aria-label="Limpar busca"
        >
          <mat-icon fontSet="material-icons">clear</mat-icon>
        </button>
      }
    </div>

    @if (inputError) {
      <div class="error-message">
        <mat-icon fontSet="material-icons" class="error-icon">error</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>
    }
  </div>
</div>
